import React from 'react';
import PropTypes from 'prop-types';
import { Card, Form } from 'react-bootstrap-5';

import { Button } from 'components/ui/button';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';
import DefaultPageRow from './default_page_row';
import { MARKET_OVERVIEW_SLOT, isMarketOverviewSlot } from './market_overview_slot';
import { getPageKey } from './page_key_helper';

export class DefaultPages extends React.Component {
  static propTypes = {
    availablePages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired,
    defaultPages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired
    })),
    marketOverviewSlotEnabled: PropTypes.bool,
    onAddMarketOverviewSlot: PropTypes.func,
    onRemovePage: PropTypes.func.isRequired,
    onReorderPage: PropTypes.func.isRequired
  }

  pageFor(defaultPage) {
    if (isMarketOverviewSlot(defaultPage)) return MARKET_OVERVIEW_SLOT;

    return this.props.availablePages.find(availablePage => (
      availablePage.id === defaultPage.id && availablePage.template_type === defaultPage.template_type
    ));
  }

  render() {
    // The prop may be null if the template was created via duplication
    const defaultPages = this.props.defaultPages || [];
    // A slot already in the list stays visible and removable even with the customization off.
    const canAddSlot = this.props.marketOverviewSlotEnabled && !defaultPages.some(isMarketOverviewSlot);

    return (
      <div className="mb-4">
        <div className="my-3 d-flex align-items-center justify-content-between">
          <span><strong className="fw-semibold">Page Defaults</strong> | Click and drag pages to reorder</span>
          {canAddSlot && (
            <Button
              name="add-market-overview-slot"
              size="sm"
              variant="secondary"
              onClick={this.props.onAddMarketOverviewSlot}
            >
              Add Market Overview slot
            </Button>
          )}
        </div>
        <p className="my-3">
          The pages that will populate into the "Pages" section of the document editor
        </p>

        {/* Non functional - Needed for spacing alignment */}
        <Form.Group className="search-container invisible mb-3">
          <Form.Control type="text" />
        </Form.Group>

        <Card className="overflow-auto" style={{ maxHeight: '300px' }}>
          <ul className="list-group list-group-flush">
            {defaultPages.map((defaultPage, index) => (
              <DefaultPageRow
                index={index}
                key={getPageKey(defaultPage)}
                page={this.pageFor(defaultPage)}
                onRemovePage={this.props.onRemovePage}
                onReorder={this.props.onReorderPage}
              />
            ))}
            {defaultPages.length === 0 && (
              <Card.Body>
                <div className="text-center text-muted">
                  Using the default set of pages
                </div>
              </Card.Body>
            )}
          </ul>
        </Card>
      </div>
    );
  }
}

export default reorderableList(DefaultPages);
